import { faClose, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import "../../styles/dialog.css";
import "../../styles/dialog-frm.css";

export const WebDevDialog = ({ visible, toggleClose }) => {
    const navigateTo = useNavigate();

    return (
        <div className={classNames("st-bl-bg", { "visible": visible })}>
            <div className={classNames("dialog-box", { "zoom": visible })}>
                <div className="dialog-close">
                    <button className="cl-btn" onClick={toggleClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
                <div className={classNames("dialog-caption")}>
                    Tell Us More About Your Website
                </div>
                <div className="action-list">
                    <div className="input-container">
                        <div className="input-question">
                           What is the name of your service or organization?
                        </div>
                        <input type="text" className="txt-inpt" />
                    </div>
                    <div className="input-container">
                        <div className="input-question">
                            Briefly describe the purpose the website shall serve.
                        </div>
                        <textarea className="lng-txt"></textarea>
                    </div>
                    <div className="subm-container">
                        <button className="subm-btn">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
}